export const QUOTE_SUMMARY_MODAL_CLOSE =
  'src/QuoteSummary/QUOTE_SUMMARY_MODAL_CLOSE'
